var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 209,
    viewBox: "0 0 232 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_453)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1598_453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.227 25H57.1422C48.2271 25 41 32.231 41 41.1509V184.49C41 193.41 48.2271 200.641 57.1422 200.641H180.227C189.141 200.641 196.37 193.41 196.37 184.49V41.1509C196.37 32.231 189.141 25 180.227 25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68 77C71.866 77 75 73.866 75 70C75 66.134 71.866 63 68 63C64.134 63 61 66.134 61 70C61 73.866 64.134 77 68 77Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 63H85C83.8954 63 83 63.8954 83 65V75C83 76.1046 83.8954 77 85 77H132C133.105 77 134 76.1046 134 75V65C134 63.8954 133.105 63 132 63Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5 80H84.5C83.6716 80 83 80.6716 83 81.5C83 82.3284 83.6716 83 84.5 83H95.5C96.3284 83 97 82.3284 97 81.5C97 80.6716 96.3284 80 95.5 80Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 80H100.5C99.6716 80 99 80.6716 99 81.5C99 82.3284 99.6716 83 100.5 83H111.5C112.328 83 113 82.3284 113 81.5C113 80.6716 112.328 80 111.5 80Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 109C71.866 109 75 105.866 75 102C75 98.134 71.866 95 68 95C64.134 95 61 98.134 61 102C61 105.866 64.134 109 68 109Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 95H85C83.8954 95 83 95.8954 83 97V107C83 108.105 83.8954 109 85 109H132C133.105 109 134 108.105 134 107V97C134 95.8954 133.105 95 132 95Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5 112H84.5C83.6716 112 83 112.672 83 113.5C83 114.328 83.6716 115 84.5 115H95.5C96.3284 115 97 114.328 97 113.5C97 112.672 96.3284 112 95.5 112Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 112H100.5C99.6716 112 99 112.672 99 113.5C99 114.328 99.6716 115 100.5 115H111.5C112.328 115 113 114.328 113 113.5C113 112.672 112.328 112 111.5 112Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 141C71.866 141 75 137.866 75 134C75 130.134 71.866 127 68 127C64.134 127 61 130.134 61 134C61 137.866 64.134 141 68 141Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 127H85C83.8954 127 83 127.895 83 129V139C83 140.105 83.8954 141 85 141H132C133.105 141 134 140.105 134 139V129C134 127.895 133.105 127 132 127Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5 144H84.5C83.6716 144 83 144.672 83 145.5C83 146.328 83.6716 147 84.5 147H95.5C96.3284 147 97 146.328 97 145.5C97 144.672 96.3284 144 95.5 144Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 144H100.5C99.6716 144 99 144.672 99 145.5C99 146.328 99.6716 147 100.5 147H111.5C112.328 147 113 146.328 113 145.5C113 144.672 112.328 144 111.5 144Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1598_453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.405 53H144.379C140.304 53 137 56.3026 137 60.3766V163.649C137 167.723 140.304 171.026 144.379 171.026H215.405C219.481 171.026 222.784 167.723 222.784 163.649V60.3766C222.784 56.3026 219.481 53 215.405 53Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134 61C134 56.5817 137.582 53 142 53H215C219.418 53 223 56.5817 223 61V101H134V61Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 120C151.866 120 155 116.866 155 113C155 109.134 151.866 106 148 106C144.134 106 141 109.134 141 113C141 116.866 144.134 120 148 120Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 106H167C164.791 106 163 107.791 163 110V116C163 118.209 164.791 120 167 120H210C212.209 120 214 118.209 214 116V110C214 107.791 212.209 106 210 106Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 123H163V126H177V123Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 123H179V126H193V123Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 133H155V136H217V133Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 140H155V143H217V140Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 147H155V150H217V147Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 154H155V157H217V154Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 161H155V164H217V161Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1598_453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48.4716C56 52.8898 52.4183 56.4716 48 56.4716H8C3.58172 56.4716 0 52.8898 0 48.4716V8Z",
    fill: "#FFFDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2387 16.8775L33.3139 16.898C34.566 17.2338 35.5575 17.4991 36.3373 17.7814C37.1352 18.0694 37.7864 18.3983 38.3225 18.9003C39.1028 19.6317 39.6487 20.5781 39.8911 21.6198C40.0585 22.3347 40.0186 23.0632 39.8684 23.8976C39.7238 24.7149 39.4586 25.7064 39.1228 26.9574L38.5126 29.233C38.178 30.484 37.9116 31.4755 37.6304 32.2564C37.3413 33.0532 37.0123 33.7043 36.5103 34.2405C35.8028 34.9959 34.8933 35.5325 33.8899 35.7863C33.5959 36.4603 33.1675 37.0673 32.6309 37.5701C32.0947 38.0721 31.4436 38.4011 30.6456 38.6902C29.8659 38.9725 28.8744 39.2377 27.6234 39.5735L27.5471 39.594C26.2949 39.9287 25.3046 40.1939 24.4873 40.3408C23.6529 40.4899 22.9243 40.5297 22.2083 40.3635C21.1668 40.1203 20.2208 39.5736 19.49 38.7927C18.9891 38.2576 18.659 37.6065 18.3699 36.8085C18.0887 36.0288 17.8235 35.0373 17.4877 33.7851L16.8775 31.5108C16.5429 30.2586 16.2765 29.2682 16.1308 28.4509C15.9817 27.6165 15.9418 26.888 16.108 26.172C16.3513 25.1305 16.8979 24.1845 17.6789 23.4537C18.2139 22.9528 18.865 22.6227 19.663 22.3335C20.4428 22.0524 21.4343 21.7871 22.6853 21.4513L22.724 21.44L23.5789 21.2123C24.0251 19.6198 24.4167 18.494 25.1816 17.6778C25.9126 16.8972 26.8586 16.351 27.9 16.108C28.616 15.9418 29.3434 15.9817 30.1789 16.1308C30.9951 16.2765 31.9866 16.5429 33.2387 16.8775ZM23.0632 23.1178C21.819 23.4514 20.9277 23.6927 20.2424 23.9397C19.548 24.1902 19.1417 24.4224 18.8457 24.7001C18.3114 25.2002 17.9375 25.8475 17.7711 26.5602C17.68 26.9563 17.6812 27.4253 17.8121 28.1504C17.943 28.8869 18.19 29.809 18.5372 31.1066L19.1269 33.3059C19.4741 34.6036 19.7222 35.5256 19.9761 36.228C20.2265 36.9224 20.4587 37.3299 20.7365 37.6259C21.2365 38.1601 21.8838 38.5341 22.5965 38.7004C22.9915 38.7915 23.4616 38.7892 24.1867 38.6595C24.9232 38.5286 25.8453 38.2815 27.143 37.9344C28.4407 37.586 29.3627 37.339 30.0662 37.084C30.7595 36.8336 31.167 36.6014 31.4629 36.3248C31.62 36.1768 31.7627 36.0178 31.891 35.8478C31.6798 35.8177 31.4695 35.7816 31.2603 35.7397C30.4954 35.5871 29.5756 35.3412 28.443 35.0373L28.3769 35.0202C27.1259 34.6844 26.1344 34.4192 25.3547 34.1369C24.5567 33.8489 23.9056 33.5199 23.3694 33.0179C22.5887 32.2866 22.0424 31.3402 21.7997 30.2984C21.6335 29.5836 21.6733 28.855 21.8224 28.0206C21.9681 27.2033 22.2345 26.2118 22.5692 24.9608L23.0632 23.1178ZM29.8784 17.8121C29.1521 17.6812 28.6831 17.6789 28.2881 17.7711C27.5755 17.9375 26.9282 18.3114 26.4281 18.8457C25.9318 19.375 25.6256 20.1946 25.0951 22.1389L24.8185 23.1657L24.2289 25.3649C23.8817 26.6626 23.6347 27.5847 23.5037 28.3212C23.3728 29.0463 23.3706 29.5164 23.4628 29.9114C23.6291 30.624 24.0031 31.2713 24.5373 31.7714C24.8333 32.0492 25.2408 32.2803 25.9341 32.5318C26.6376 32.7857 27.5596 33.0327 28.8573 33.381C30.0241 33.6941 30.8892 33.9252 31.5927 34.064C32.2928 34.204 32.7686 34.2382 33.1579 34.1904C33.2429 34.179 33.3249 34.1646 33.4038 34.1471C34.1164 33.9808 34.7637 33.6068 35.2638 33.0725C35.5416 32.7766 35.7738 32.3691 36.0242 31.6758C36.2781 30.9723 36.5251 30.0503 36.8734 28.7526L37.4631 26.5533C37.8103 25.2556 38.0573 24.3336 38.1882 23.5971C38.318 22.872 38.3214 22.4018 38.2292 22.0068C38.0628 21.2942 37.6889 20.6469 37.1546 20.1468C36.8586 19.8691 36.4511 19.638 35.7579 19.3864C35.0532 19.1326 34.1323 18.8855 32.8346 18.5372C31.5369 18.19 30.6149 17.943 29.8784 17.8121ZM27.1578 25.7394C27.1868 25.6311 27.2369 25.5296 27.3052 25.4406C27.3736 25.3517 27.4587 25.2771 27.5559 25.221C27.653 25.165 27.7602 25.1287 27.8714 25.1141C27.9826 25.0995 28.0956 25.107 28.2039 25.1361L33.702 26.6091C33.9147 26.673 34.094 26.8173 34.2021 27.0113C34.3101 27.2053 34.3383 27.4338 34.2807 27.6482C34.2231 27.8626 34.0842 28.0462 33.8935 28.1599C33.7028 28.2737 33.4753 28.3086 33.2592 28.2574L27.7611 26.7844C27.5426 26.7257 27.3563 26.5827 27.2432 26.3868C27.1301 26.1908 27.0994 25.958 27.1578 25.7394ZM26.2733 29.0383C26.3023 28.9299 26.3525 28.8282 26.4209 28.7392C26.4893 28.6502 26.5745 28.5755 26.6718 28.5194C26.7691 28.4634 26.8764 28.4271 26.9878 28.4126C27.0991 28.3981 27.2122 28.4057 27.3206 28.435L30.6183 29.3183C30.837 29.3769 31.0235 29.52 31.1368 29.716C31.25 29.9121 31.2808 30.1452 31.2222 30.3639C31.1636 30.5826 31.0206 30.7691 30.8245 30.8824C30.6284 30.9956 30.3954 31.0263 30.1766 30.9678L26.8778 30.0833C26.6593 30.0246 26.473 29.8816 26.3599 29.6856C26.2467 29.4897 26.216 29.2569 26.2744 29.0383",
    fill: "#05C25E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1598_453",
    x: 37,
    y: 25,
    width: 163.369,
    height: 183.641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_453",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1598_453",
    x: 137,
    y: 53,
    width: 94.7832,
    height: 127.026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592 0 0 0 0 0.988 0 0 0 0 0.78 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_453",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1598_453",
    x: 0,
    y: 0,
    width: 65,
    height: 65.4716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592 0 0 0 0 0.988 0 0 0 0 0.78 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_453",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 209,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome3);
export default __webpack_public_path__ + "static/media/home_3.9f600f060b3edebf7895d5126a66f0dd.svg";
export { ForwardRef as ReactComponent };